/* global require */
(function ($) {
    // plugin to build progress-ring
    const _ = require('lodash');

    $.fn.efw$progressRing = function (options) {
        var opts = $.extend({}, $.fn.efw$progressRing.defaults, options);
        //console.log('here i am: ' + JSON.stringify(opts));

        return this.each(function () {
            // create a canvas.
            let $cvs = $('<canvas />');

            $cvs.attr('height', opts.height)
                .attr('width', opts.width);

            $(this).append($cvs);

            if ($cvs[0].getContext) {
                let ctx = $cvs[0].getContext('2d'),
                    zero = -Math.PI / 2,
                    pct = _.toFinite($(this).data('progress')),
                    angle = zero + (2 * Math.PI) * pct;

                if (pct) {
                    //ctx.fillRect(0, 0, opts.width, opts.height);

                    // full circle
                    ctx.strokeStyle = opts.ringBackColor;
                    ctx.lineWidth = opts.stroke;
                    ctx.lineCap = 'round';
                    ctx.beginPath();
                    ctx.arc(opts.height / 2, opts.width / 2, (opts.height - opts.stroke) / 2, - Math.PI / 2, 3 * Math.PI / 2, false);
                    ctx.stroke();

                    // progress circle
                    ctx.strokeStyle = opts.ringColor;
                    ctx.lineWidth = opts.stroke;
                    ctx.beginPath();
                    ctx.arc(opts.height / 2, opts.width / 2, (opts.height - opts.stroke) / 2, -Math.PI / 2, angle, false);
                    ctx.stroke();
                }
            }
        });
    };

    $.fn.efw$progressRing.defaults = { height: 23, width: 23, stroke: 3, ringColor: '#008040', ringBackColor: '#d8d8d8' };

    // activate globally.
    $(document).ready(function () {
        $('.progress-widget').efw$progressRing();
    });
})(jQuery);